import Subject from "../cse4sub/Subject";
import React from 'react'

export default function Wpm() {
  return (
    <div>
       <Subject title="Workshop/Manufacturing Practices(ASH105)" sub="Workshop" syllabus="#"
    book1=" Kalpakjian S. And Steven S. Schmid, ―Manufacturing Engineering and Technology‖, 4th edition, Pearson
    Education India Edition, 2002." 
    book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=144739960&h=a7bf4d7564995b3f79d8c2eade276609&u=cache&ext=pdf" 
    book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}